import classNames from 'classnames'
import React from 'react'

export const Button = (props: any) => {
  const { className } = props
  const inputClass = classNames(`hover:bg-hover  ${className}`)
  return <button {...props} className={inputClass}></button>
}
